/* tslint:disable:jsx-no-lambda */
import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { Text, TryWithExpo } from "../components";
import Counter from "./Counter";

type ClassNames = "container" | "stats" | "qrCode";

// tslint-disable-next-line
const apk = "https://firebasestorage.googleapis.com/v0/b/react-native-ui-kits.appspot.com/o/builds%2Fandroid%2Freact-native-elements-db9cd52f681e479b8c8739ebe7b6e0df-signed.apk?alt=media&token=b4681b30-b821-45d8-893e-6368bfd66123";
const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        backgroundColor: "#fafafa",
        padding: theme.spacing.unit * 4
    },
    stats: {
        display: "flex",
        justifyContent: "center"
    },
    qrCode: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: theme.spacing.unit * 4
    }
});

interface IntroProps {
    noop?: boolean
}

interface CounterComp {
    start: () => void
}

class Intro extends React.Component<WithStyles<ClassNames> & IntroProps> {

    public apps: CounterComp | null;
    public screens: CounterComp | null;
    public comps: CounterComp | null;

    public start() {
        if (this.apps && this.screens && this.comps) {
            this.apps.start();
            this.screens.start();
            this.comps.start();
        }
    }

    public render() {
        const {classes} = this.props;
        const theme = this.props.theme as Theme;
        return (
            <div className={classes.container} id="intro">
                <Text variant="title2" align="center">
                We've done our magic
                <br />
                Time to do yours
                </Text>
                <Text align="center">
                React Native Elements covers a wide variety of use cases, fully functional on iOS and Android.
                <br />
                All the bases for your next project are covered: Social Media, Music, Blogging, Photo editing, and more.
                <br />
                This is a highest quality codebase you can get for your next project.
                </Text>
                <div className={classes.stats}>
                    <Counter innerRef={apps => this.apps = apps} label="Apps" from={1} to={5} />
                    <Counter innerRef={screens => this.screens = screens} label="Screens" from={5} to={35} />
                    <Counter innerRef={comps => this.comps = comps} label="Components" from={35} to={75} />
                </div>
                <div className={classes.qrCode}>
                    <Text variant="title3">Try it on your device</Text>
                    <TryWithExpo
                        name="React Native Sketch Elements"
                        expo="exp://exp.host/@wcandillon/react-native-elements"
                        color={theme.palette.primary[500]}
                        testFlight="https://testflight.apple.com/join/u9Ligqwa"
                        apk={apk}
                    />
                </div>
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })<IntroProps>(Intro);



// WEBPACK FOOTER //
// ./src/elements/Intro.tsx